// extracted by mini-css-extract-plugin
export default {"page":"NotFoundPage_page__NMRaN"};